/**
 * @fileoverview Logic for the component that is rendered into table, contains mission actions
 */
import React from 'react'
import { withRouter } from 'react-router-dom'
import { authorization } from '../../Module/Auth/Auth'
import { MISSION_STATUS_ENUM, STATUS_BOOKED } from '../../shared/constants'
import { LinkView } from '../Link/View'
import { ButtonDeleteInline } from '../Buttons/ButtonDeleteInline'
import MapPointEdit from '../../Assets/Images/icons/mapPointEdit '
import MapPointAdd from '../../Assets/Images/icons/mapPointAdd'
import { Tooltip } from '@material-ui/core'

/**
 * Component that used as controls for mission table row
 * @param {number} props.missionId Mission's id
 * @param {number} props.statusNumber Mission's status
 * @param {function} props.deleteMissions Function for mission deletion
 * @param {object} props.match Router's match object, used for link generation
 *
 * @returns {JSX.Element}
 */
const MissionTableActions = withRouter(
  ({
    missionId,
    statusNumber,
    onDelete,
    match,
    meetingPoint,
    onEditMeetingPoint,
    mission,
  }) => {
    const isMissionAvailableForMeetingPoint = [
      MISSION_STATUS_ENUM.DRAFT,
      MISSION_STATUS_ENUM.AVAILABLE,
      MISSION_STATUS_ENUM.BOOKED,
    ].includes(mission.status)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <LinkView to={`${match.url}/${missionId}`} />
        {(authorization.isAdmin() || authorization.isCityManager()) &&
          statusNumber < STATUS_BOOKED && (
            <ButtonDeleteInline
              onClickHandler={e => {
                e.preventDefault()
                e.stopPropagation()
                return onDelete(missionId)
              }}
            />
          )}
        {isMissionAvailableForMeetingPoint && meetingPoint ? (
          <Tooltip
            title="Edit meeting point"
            enterDelay={200}
            leaveDelay={0}
            placement="top"
          >
            <div
              onClick={() => onEditMeetingPoint({ mission })}
              style={{ cursor: 'pointer', marginTop: -1 }}
            >
              <MapPointEdit />
            </div>
          </Tooltip>
        ) : isMissionAvailableForMeetingPoint && !meetingPoint ? (
          <Tooltip
            title="Add meeting point"
            enterDelay={200}
            leaveDelay={0}
            placement="top"
          >
            <div
              onClick={() => onEditMeetingPoint({ mission })}
              style={{ cursor: 'pointer', marginTop: -1 }}
            >
              <MapPointAdd />
            </div>
          </Tooltip>
        ) : null}
      </div>
    )
  },
)

export default MissionTableActions
